import { ToggleButton, ToggleButtonGroup, styled } from "@mui/material";

export function ButtonAction({ items, value, onChange, buttonAction, justifyContent = "center" }) {
  const handleChange = (_, val) => {
    if (val) {
      onChange(val);
    }
  };

  return (
    <ToggleButtonGroupStyle
      color="secondary"
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
      sx={{ justifyContent: justifyContent }}
    >
      {items?.map((item) => (
        <ToggleButtonStyle
          smallText={item.smallText}
          value={item?.value}
          key={item?.value}
          buttonAction={buttonAction}
        >
          {item?.text}
        </ToggleButtonStyle>
      ))}
    </ToggleButtonGroupStyle>
  );
}

const ToggleButtonGroupStyle = styled(ToggleButtonGroup)(({ theme }) => ({
  marginRight: theme.spacing(-0.5),
  marginLeft: theme.spacing(-0.5),
  display: "flex",
}));

const ToggleButtonStyle = styled(ToggleButton)(
  ({ theme, smallText, buttonAction }) => ({
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    backgroundColor: buttonAction
      ? theme.palette.background.button
      : theme.palette.background.buttonAction,
    borderRadius: "8px !important",
    fontSize: smallText ? "12px" : "14px",
    fontWeight: "400",
    height: "35px",
    display: "flex",
    alignItems: "center",
    lineHeight: 0,
    justifyContent: "center",
    padding: theme.spacing(0.4),
    width: "105px",
    maxWidth: "100%",
    color: buttonAction ? theme.palette.background.tabButtonHoverColor : theme.palette.modules.buttonColor,
    border: "none",
    textTransform: "none",
    transition: "all 0.3s",

    "&:hover": {
      color: theme.palette.background.tabButtonHoverColor,
      backgroundColor: `${theme.palette.background.tabButtonHover} !important`,
    },

    "&.Mui-selected": {
      color: theme.palette.modules.buttonColor,
      backgroundColor: `${theme.palette.background.buttonAction}`,

      "&:hover": {
        backgroundColor: `${theme.palette.background.buttonAction} !important`,
      },
    },
  })
);

export default ButtonAction;
